import React from 'react'
import { Outlet } from 'react-router-dom'


const AttendenceDashboard = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default AttendenceDashboard